import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
export const TEAM_MODULES = ['tasks', 'guests', 'budget', 'timeline'] as const;
export type TeamModule = (typeof TEAM_MODULES)[number];
export type TeamRole = 'view' | 'edit';
export interface TeamEvent {
  id: string;
  name: string;
  type: string;
  isGeneric: boolean;
  userId?: string;
  teamKey?: string;
  date?: unknown;
  targetId?: string;
}
export interface TeamMember {
  id: string;
  teamKey: string;
  event: TeamEvent;
  userId: string;
  ownerId: string;
  email: string;
  role: TeamRole;
  modules: TeamModule[];
  status: string;
}
export interface TeamInvitation {
  id: string;
  event: TeamEvent;
  email: string;
  role: TeamRole;
  modules: TeamModule[];
  status: string;
  expiresAt: number;
  delivery?: string;
}
export interface TeamList {
  members: TeamMember[];
  invitations: TeamInvitation[];
  legacyCount: number;
  legacy?: { id: string; email: string | null; kind: string }[];
}
const call = httpsCallable<Record<string, unknown>, any>(functions, 'teamAccess');
export const teamService = {
  request: async <T = any>(action: string, data: Record<string, unknown> = {}): Promise<T> =>
    (await call({ action, ...data })).data,
};
